import React from 'react'
import * as styles from "../styles/meettheteams.module.css"
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

export default function MeetTheTeams() {
    const breakpoints = useBreakpoint();
    if (breakpoints.tablet) {
        return (
            <section className={styles.containerMobile}>
                <div>
                    <h1 className={styles.titleMobile}>Meet the teams</h1>
                </div>
                <div className={styles.teamsMobile}>
                    <div className={styles.column}>
                        <img src="images/team-banners/valorant.png" alt="Hero" className={styles.images} />
                        <div className={styles.spacer}></div>
                        <img src="images/team-banners/leaguerift.png" alt="Hero" className={styles.images} />
                    </div>
                    <div className={styles.spacer}></div>
                    <div className={styles.column}>
                        <img src="images/team-banners/league.png" alt="Hero" className={styles.images} />
                        <div className={styles.spacer}></div>
                        <img src="images/team-banners/pubgm.png" alt="Hero" className={styles.images} />
                    </div>
                </div>
            </section>
        )
    } else if (breakpoints.sm) {
        return (
            <section className={styles.containerSM}>
                <div>
                    <h1 className={styles.titleMobile}>Meet the teams</h1>
                </div>
                <div className={styles.teamsMobile}>
                    <div className={styles.column}>
                        <img src="images/team-banners/valorant.png" alt="Hero" className={styles.images} />
                        <div className={styles.spacer}></div>
                        <img src="images/team-banners/leaguerift.png" alt="Hero" className={styles.images} />
                    </div>
                    <div className={styles.spacer}></div>
                    <div className={styles.column}>
                        <img src="images/team-banners/league.png" alt="Hero" className={styles.images} />
                        <div className={styles.spacer}></div>
                        <img src="images/team-banners/pubgm.png" alt="Hero" className={styles.images} />
                    </div>
                </div>
            </section>
        )
    } else {
        return (
            <section className={styles.container}>
                <div>
                    <h1 className={styles.title}>Meet the teams</h1>
                </div>
                <div className={styles.teams}>
                    <div className={styles.column}>
                        <img src="images/team-banners/valorant.png" alt="Hero" className={styles.images} />
                        <div className={styles.spacer}></div>
                        <img src="images/team-banners/leaguerift.png" alt="Hero" className={styles.images} />
                    </div>
                    <div className={styles.spacer}></div>
                    <div className={styles.column}>
                        <img src="images/team-banners/league.png" alt="Hero" className={styles.images} />
                        <div className={styles.spacer}></div>
                        <img src="images/team-banners/pubgm.png" alt="Hero" className={styles.images} />
                    </div>
                </div>
            </section>
        )
    }
}
